import { formatGbp, formatVerificationRate, weekOverWeekGrowth } from './analyticsFormat';

export function normalizeOverviewPayload(data = {}) {
  const users = data.users || {};
  const sessions = data.sessions || {};
  const gf = data.guestFunnel;
  const growth = weekOverWeekGrowth(data.growth?.daily);
  const orders = data.orders || {};
  const currency = orders.currency || 'GBP';
  const money = (n) => (n == null ? null : formatGbp(n, currency));

  return {
    users,
    sessions,
    gf,
    growth,
    verificationLabel: formatVerificationRate(users.verificationRate),
    recentActivity: data.recentActivity || { recentLogins: [], recentRegistrations: [] },
    daily: data.growth?.daily || [],
    enterprises: data.enterprises || { count: 0, billingAttention: 0, newEnquiries: 0 },
    orders: {
      configured: orders.configured,
      today: orders.today ?? null,
      revenueToday: orders.revenueTodayGross != null ? money(orders.revenueTodayGross) : orders.revenueToday ?? null,
      revenue7d: orders.revenue7dGross != null ? money(orders.revenue7dGross) : orders.revenue7d ?? null,
    },
    fulfilment: data.fulfilment || null,
    campaigns: data.campaigns || { count: 0, issued: 0, activation: null },
    applications: data.applications || { total: null, neu: null },
    security: data.security || null,
    errors: data.errors || {},
  };
}

export function overviewAttention(snapshot) {
  const items = [];
  if ((snapshot.enterprises?.billingAttention || 0) > 0) {
    items.push({
      id: 'billing',
      to: '/admin/enterprise',
      label: `${snapshot.enterprises.billingAttention} compan${snapshot.enterprises.billingAttention === 1 ? 'y' : 'ies'} need billing attention`,
    });
  }
  if ((snapshot.enterprises?.newEnquiries || 0) > 0) {
    items.push({
      id: 'enquiries',
      to: '/admin/enterprise',
      label: `${snapshot.enterprises.newEnquiries} new enterprise enquir${snapshot.enterprises.newEnquiries === 1 ? 'y' : 'ies'}`,
    });
  }
  if ((snapshot.applications?.neu || 0) > 0) {
    items.push({
      id: 'apps',
      to: '/admin/applications',
      label: `${snapshot.applications.neu} new membership application${snapshot.applications.neu === 1 ? '' : 's'}`,
    });
  }
  if ((snapshot.fulfilment?.flaggedForReview || 0) > 0) {
    items.push({
      id: 'fulfilment',
      to: '/admin/fulfilment',
      label: `${snapshot.fulfilment.flaggedForReview} fulfilment row${snapshot.fulfilment.flaggedForReview === 1 ? '' : 's'} flagged for review`,
    });
  }
  if ((snapshot.security?.critical || 0) > 0) {
    items.push({
      id: 'security',
      to: '/admin/security',
      label: `${snapshot.security.critical} critical security event${snapshot.security.critical === 1 ? '' : 's'}`,
    });
  }
  return items;
}
